import { useStaticIntl } from '@tribeplatform/react-components/i18n'
import { useBlock } from '@tribeplatform/react-slate-kit/hooks'
import type { BC } from '@tribeplatform/react-slate-kit/types'

import { MultiViewBlock } from '../Views/components/MultiViewBlock'
import { NetworkPostsList } from './components/NetworkPostsList'
import { SpacePostsList } from './components/SpacePostsList'
import { genericViewFactory, staticFieldsFactory } from './config'
import type { PostsBlockProps } from './types'

export const PostsBlock: BC<PostsBlockProps> = ({
  title,
  description,
  linkText,
  linkUrl,
  views,
}) => {
  const {
    extraContext: { activeViewIndex, activeFieldId },
  } = useBlock<
    PostsBlockProps,
    { activeViewIndex?: number; activeFieldId?: string }
  >()
  const genericView = useStaticIntl(genericViewFactory)
  const staticFields = useStaticIntl(staticFieldsFactory)

  return (
    <MultiViewBlock
      activeViewIndex={activeViewIndex}
      title={title}
      description={description}
      views={views}
      linkUrl={linkUrl}
      linkText={linkText}
    >
      {({ view, preview }) => (
        <>
          {view && view.spaceId && (
            <SpacePostsList
              view={view}
              activeFieldId={activeFieldId}
              preview={preview}
            />
          )}
          {view && !view.spaceId && (
            <NetworkPostsList
              view={view}
              activeFieldId={activeFieldId}
              preview={preview}
            />
          )}
          {!view && (
            <NetworkPostsList
              activeFieldId={activeFieldId}
              view={{
                ...genericView,
                fields: staticFields,
              }}
              preview={preview}
            />
          )}
        </>
      )}
    </MultiViewBlock>
  )
}
